import styled from "styled-components"
import { Text } from "rebass"
import { grey800 } from "material-ui/styles/colors"

const Header = styled(Text)`
  font-family: "Montserrat", "sans-serif";
  font-weight: 400;
  letter-spacing: 1.25px;
  line-height: "100%";
  color: ${grey800};
`
export default Header



// WEBPACK FOOTER //
// ./src/contents/editorPreview/components/productcard/Header.js